import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import SafeLanguageDetector from './safe-language-detector';
import enTranslation from './locales/en';
import idTranslation from './locales/id';
import zhCNTranslation from './locales/zh-CN';

console.log("i18n.ts: Starting i18next configuration");

// Define translations for languages
const resources = {
  en: {
    translation: enTranslation
  },
  id: {
    translation: idTranslation
  },
  'zh-CN': {
    translation: zhCNTranslation
  }
};

i18n
  // detect user language with safe localStorage handling
  .use(SafeLanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // Language detection is handled in I18nProvider to support async geolocation
    // SafeLanguageDetector provides localStorage fallback without throwing SecurityError
  });

console.log("i18n.ts: i18next configuration file loaded");

export default i18n;
